import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

/**
 * <TemplateAmountDialog template amount onSetAmount = {template, amount} onCancel = {} />
 */

class TemplateAmountDialog extends Component {

	state = {
		amount: "",
	}

	componentDidMount() {
		this.setState({
			amount: this.props.amount
		})
	}

	isUnsignedNumber(value) {
		let s = value.toString()
		for (let i = 0; i < s.length; i++) {
			if ((s[i] < '0') || (s[i] > '9')) {
				return false
			}
		}
		return true
	}

	isReadyToCreate() {
		return this.state.amount !== "" && this.isUnsignedNumber(this.state.amount)
	}

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Количество
			</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>

				<TextField
					value = {this.state.amount}
					label = "Количество"
					margin = "normal"
					onChange = {e => {
						this.setState({
							amount: e.target.value
						})
					}}
				/>

			</DialogContent>

			<DialogActions>

				<Button
					disabled = {!this.isReadyToCreate()}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onSetAmount === "function") {
							this.props.onSetAmount(this.props.template, this.state.amount)
						}
					}}
				>Ок</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default TemplateAmountDialog
